module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-4feb7e5e.png";